var _circle, _circle2, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePasswordSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 162,
    viewBox: "0 0 163 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0831655,
    cx: 81.35,
    cy: 80.85,
    r: 80.85,
    fill: "#FAA100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.18,
    cx: 81.3497,
    cy: 80.8497,
    r: 54.67,
    fill: "#FAA100"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.7891,
    y: 60.8301,
    width: 40.81,
    height: 33.88,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5508 78.5402C50.5508 61.5564 64.3681 47.7402 81.3508 47.7402C98.3334 47.7402 112.151 61.5564 112.151 78.5402C112.151 95.5241 98.3334 109.34 81.3508 109.34C64.3681 109.34 50.5508 95.5241 50.5508 78.5402ZM79.5679 89.5915L98.5218 68.2684C99.3913 67.2899 99.3024 65.7926 98.324 64.9219C97.3466 64.0524 95.8469 64.14 94.9798 65.1185L77.5197 84.7607L67.4304 76.6899C66.4092 75.8725 64.9166 76.0383 64.1004 77.0606C63.283 78.083 63.4489 79.5744 64.47 80.3906L76.3162 89.8675C76.7533 90.2158 77.2757 90.3864 77.7957 90.3864C78.4508 90.3864 79.1012 90.1163 79.5679 89.5915Z",
    fill: "#FAA100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordSuccess);
export default __webpack_public_path__ + "static/media/change-password-success.cfb602304c4754ed199073a357653725.svg";
export { ForwardRef as ReactComponent };